const doc = [({"id":"it", "name":"Italia", "active":true, "isHuffPostMainSite":true, "locale":"it_IT", "link":"https://www.huffingtonpost.it"})];
module.exports = doc.length <= 1 ? doc[0] : doc;